export default __webpack_public_path__ + "static/media/deployment.d3f1e4fc.png";